<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ch2-1">
<p class="centerImage"><img alt="image" src="images/img17.jpg" style="max-width: 100%"/></p>
<p class="caption"><em class="italic">Location map 2.</em> <span class="smallcaps">The author</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 17_ch21.vue?a824e992